import { FieldShell } from '@atlas/ui-components'
import { ListBoxItem, Select } from '@atlas/ui-primitives'

/** A labelled Select over a `{ value: label }` map (used for the enum fields). */
export function EnumField<T extends string>({
	label,
	value,
	labels,
	onChange,
}: {
	label: string
	value: T
	labels: Record<T, string>
	onChange: (v: T) => void
}) {
	return (
		<FieldShell label={label}>
			<Select aria-label={label} selectedKey={value} onSelectionChange={(k) => onChange(k as T)}>
				{(Object.keys(labels) as T[]).map((k) => (
					<ListBoxItem key={k} id={k}>
						{labels[k]}
					</ListBoxItem>
				))}
			</Select>
		</FieldShell>
	)
}
